module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/479c3dcb836b638e0bf8e9cadf5f5e3b.png";